import React, { useContext } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CrclContext from "../../containers/Crcl/contexts/CrclContext";
import { withRouter } from "react-router";

const AlertDialog = (props) => {
  const crclcontext = useContext(CrclContext);

  const onClose = () => {
    crclcontext.update({ alertDialog: false });
  };

  /*const backToCalc = (e) => {
    e.preventDefault();
    props.history.push("/calculator");
    crclcontext.update({ alertDialog: false });
  };*/

  return (
    <div>
      <Dialog
        open={crclcontext.alertDialog}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          {crclcontext.alertTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {crclcontext.validationText.warningText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={onClose} color="primary">
              OK
            </Button>
          {/* {crclcontext.calcStop ? (
            <Button onClick={onClose} color="primary">
              OK
            </Button>
          ) : (
            <div>
              <Button onClick={backToCalc} color="primary">
                NO
              </Button>
              <Button onClick={onClose} color="primary">
                YES
              </Button>
            </div>
          )} */}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withRouter(AlertDialog);
